import {
    programIsFuture,
    programIsPrevious,
    programRunningNow,
} from '@/shared/constants/epgConstants'

export const checkIfProgramCurrentlyRuns = (
    startMilis: number,
    endMilis: number
) => {
    const actualDate = Date.now()

    if (startMilis <= actualDate && actualDate <= endMilis) {
        return programRunningNow
    } else if (actualDate < startMilis) {
        return programIsFuture
    } else {
        return programIsPrevious
    }
}
